import { LayoutType } from 'ag-common-lib/lib';
import {
  LookupBase,
  LookupKeys,
  Social,
  SocialMediaColorStyle,
  type SocialMediaColorStyleId,
  SOCIAL_MEDIA_WIDGET_DEFAULT_GAP_PX,
  SOCIAL_MEDIA_WIDGET_DEFAULT_ICON_SIZE_PX,
  SOCIAL_MEDIA_DEFAULT_BRAND_SHAPE_COLOR,
  SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR,
} from '@ag-common-lib/public-api';
import { AlignItems } from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-align-items.model';

export enum SocialMediaWidgetKeys {
  colorStyle = 'colorStyle',
  shapeColor = 'shapeColor',
  iconColor = 'iconColor',
  layout = 'layout',
  alignItems = 'alignItems',
  shape = 'shape',
  iconSize = 'iconSize',
  gap = 'gap',
  socialListType = 'socialListType',
  socials = 'socials',
}

export enum SocialMediaListType {
  default = 'default',
  custom = 'custom',
}

export enum SocialMediaShape {
  circle = 'circle',
  square = 'square',
  rounded = 'rounded',
  noFrame = 'noFrame',
}

export const SOCIAL_MEDIA_SHAPE_LOOKUP: LookupBase[] = [
  { [LookupKeys.value]: SocialMediaShape.noFrame, [LookupKeys.description]: 'No frame' },
  { [LookupKeys.value]: SocialMediaShape.circle, [LookupKeys.description]: 'Circle' },
  { [LookupKeys.value]: SocialMediaShape.rounded, [LookupKeys.description]: 'Rounded' },
  { [LookupKeys.value]: SocialMediaShape.square, [LookupKeys.description]: 'Square' },
];

export class SocialMediaWidgetData {
  [SocialMediaWidgetKeys.colorStyle]: SocialMediaColorStyleId = SocialMediaColorStyle.brandColors;
  [SocialMediaWidgetKeys.shapeColor]: string = SOCIAL_MEDIA_DEFAULT_BRAND_SHAPE_COLOR;
  [SocialMediaWidgetKeys.iconColor]: string = SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR;
  [SocialMediaWidgetKeys.shape]: SocialMediaShape = SocialMediaShape.circle;
  [SocialMediaWidgetKeys.iconSize]: number = SOCIAL_MEDIA_WIDGET_DEFAULT_ICON_SIZE_PX;
  [SocialMediaWidgetKeys.gap]: number = SOCIAL_MEDIA_WIDGET_DEFAULT_GAP_PX;
  [SocialMediaWidgetKeys.layout]: LayoutType = LayoutType.vertical;
  [SocialMediaWidgetKeys.alignItems]: AlignItems = AlignItems.center;
  [SocialMediaWidgetKeys.socialListType]: SocialMediaListType = SocialMediaListType.default;
  [SocialMediaWidgetKeys.socials]: Partial<Social>[] = [];
}
